import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Alert, Row, Col } from 'antd';
import './message.css';
import trans from './translation';
import { Config } from '../../public/js/config';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let Message = (props, ref) => {

    const [style, setStyle] = useState("");
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [type, setType] = useState("messageShowStyle");
    const [isShow, setIsShow] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            setStyle,
            setTitle,
            setContent,
            setType,
            setIsShow
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {
        let newTitle;
        switch (style) {
            case 'error': newTitle = trans.error[Config.backLang];
                break;
            case 'success': newTitle = trans.information[Config.backLang];
                break;
            case 'warning': newTitle = trans.warning[Config.backLang];
                break;
            default: newTitle = trans.information[Config.backLang];
                break;
        }
        setTitle(newTitle);
    }, [style]);

    /**
     * 消息内容换行处理
     */
    useEffect(() => {
        let arr = content.split(';');
        if (arr.length > 1) {
            let index = 1;
            let newContent = '';
            arr.map((item) => {
                if (item.trim() !== '') {
                    newContent += index++ + '.' + item + '\n'
                }
            });
            setContent(newContent);
        }
    }, [content]);

    return (
        <>
            {
                isShow && 
                    <Row className={type}>
                    <Col xs={24} md={24} className={style}>  
                        <Alert 
                            className='messageAlert'
                            message={title}
                            description={content}
                            type={style}
                            closable 
                            onClose={()=> setIsShow(false)}
                        />
                    </Col>
                </Row>
            }
            </>
    )

}

Message = forwardRef(Message);

export default Message;